/**
 * @file pendingCertificate.ts
 * @module api/apiJSON/pendingCertificate
 * @description Defines pendingCertificate API request configuration and payload helpers.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 1.2.5
 */

import { IListPendingCertificate } from "../../types";
export const pendingCertificatesJSON = {
  listCertificates: ({
    pageNo,
    limit,
    sortKey,
    sortOrder,
    warehouse,
  }: IListPendingCertificate) => {
    let params: any = {
      pageNo: pageNo,
      limit: limit,
      sortKey: sortKey,
      sortOrder: sortOrder,
      needCount: true,
    };
    if (warehouse) {
      params.warehouse = warehouse;
    }
    return params;
  },
};
